import React, { useState } from 'react';
import { Layout, Row, Col } from 'antd';

import { UploadUIMenuContainer } from './UploadUIMenuContainer';
import { UploadUIStepContainer } from './UploadUIStepContainer';

import logo from '../../../public/images/logo.png';
import aloneLogo from '../../../public/images/gst-input-logo-alone.png';

const { Sider, Content } = Layout;

const UploadUIContainer = props => {
	const [collapsed, onCollapse] = useState(false);
	const [currentStep, updateCurrentStep] = useState(1);

	const onMenuItemClick = stepId => e => {
		updateCurrentStep(stepId);
	};

	return (
		<Layout style={{ width: '100vw', minHeight: '100vh' }}>
			<Sider
				width={256}
				theme="light"
				collapsible
				collapsed={collapsed}
				onCollapse={onCollapse}
			>
				<img
					src={!collapsed ? logo : aloneLogo}
					alt="logo.png"
					style={{
						backgroundColor: '#ddd9',
						margin: '5px',
						padding: 0,
						width: '90%',
					}}
				/>
				<UploadUIMenuContainer
					onMenuItemClick={onMenuItemClick}
					{...props}
				/>
			</Sider>
			<Layout>
				<Content>
					<Row style={{ width: '100%' }}>
						<Col span={24}>
							<UploadUIStepContainer
								currentStep={currentStep}
								{...props}
							/>
						</Col>
					</Row>
				</Content>
			</Layout>
		</Layout>
	);
};

export default UploadUIContainer;
